// @ts-nocheck

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {appPaginationStore} from "@/store/modules/appPagination";
import {ProxyForm} from "@/UI/components/Helpers/ProxyForm";
import {AppStateStore} from "@/store/modules/appState";

@Component
export class ProxyTableData extends mixins(ProxyForm) {
    @Prop() readonly source!: string;
    pagination = appPaginationStore.PageParams
    proxyFilter: any = {}

    TableLoading = true;
    data: any;
    sort_mod = false
    btn_sort = false
    proxySort: any = {
        sort: '',
        by: ''
    }

    constructor() {
        super();
    }

    async fetchModule(source_params: Record<string, any>[]): Promise<void> {
        for (const i of source_params) {
            await this.$store.dispatch(i.s + "/fetchAll", i.p)
        }
    }

// Сортировка
    async sortData(key: string, data_index: Record<string, any> = {}): Promise<void> {

        /*if (Vue.router.currentRoute.name === 'Salons') {
            key = data_index.key === '4' && key === 'asc' ? 'desc' : 'asc'
        }*/
        this.sort_mod = true // У сортировки нужно указать sort_mod = true для его включения
        this.btn_sort = true  // Кнопка очистки сортировки

        // Новый объект с сортировкой (asc - по возростанию) (desc - по убыванию)
        let sortFieldName = data_index.sortField !== undefined ? data_index.sortField : undefined;

        if (!sortFieldName && data_index.key !== undefined)
            sortFieldName = data_index.key;

        if (!sortFieldName && data_index.dataIndex !== undefined)
            sortFieldName = data_index.dataIndex;

        if (key === 'asc')
            this.proxySort = {sort: sortFieldName, by: 'asc'}

        if (key === 'desc')
            this.proxySort = {sort: sortFieldName, by: 'desc'}

        // Выкл сортировку, пустой фильтр, выкл кнопку
        if (key === 'clear') {
            this.sort_mod = false;
            this.proxySort = {};
            this.proxyFilter = {};
            this.btn_sort = false
        }

        // Вкл. кнопку сортировки
        if (key === 'on')
            this.btn_sort = true

        // Если нужна сортировка от самых новых до старых записей
        if (key === 'desc_sort') {
            this.proxySort = {sort: sortFieldName, by: 'desc'};
            this.btn_sort = false
        }
        if(this.$router.currentRoute.params.filter) {
            let filter = JSON.parse(this.$router.currentRoute.params.filter)
            filter = Object.assign(filter, this.proxySort)
            this.$router.currentRoute.params.filter = JSON.stringify(filter);
        }
        await this.createProxy()
    }


    @Watch("$route.name", {immediate: false})
    async onChangePagePagination(): Promise<void> {
        // При переходе с страницы на страницу скидывает текущую страницу в таблицу на 1 и количество записей до 10 и количество записей до 10
        if (Vue.router.currentRoute.name?.substring(Vue.router.currentRoute.name.length - 4) !== "Page") {
            appPaginationStore.setCurrent(1)
            appPaginationStore.PageParams.pageSize = 10
            //appPaginationStore.PageParams.pageSize = 10
        }

    }

    @Watch("$store.state.appState.oldApplyFilters", {immediate: false})
    async onApplyFilters(): Promise<void> {
        // AppStateStore.setApplyFilters(false);
        AppStateStore.oldSetApplyFilters(false)
        await this.ApplyTableFilter();
    }

    @Watch("$store.state.salon_id", {immediate: false})
    async onStudioChange(): Promise<void> {
        try {
            const routeParams = this.$router.currentRoute.params;
            if (Object.keys(routeParams).length) {
                await this.$router.push({
                    params: {}
                }).catch((error) => {
                    if (error.name != "NavigationDuplicated") {
                        throw error;
                    }
                });
            }
            this.proxyFilter = {}
            if (Vue.router.currentRoute.name === 'FinanceOperationsPage') this.sort_mod = true
            await this.fetchTable(this, null, this.proxyFilter);
        } catch (e) {
            console.error(e.message);
        }
    }

    async createProxy(filter?: Record<string, any>): Promise<void> {
        const RouterParams = this.$router.currentRoute.params;

        if (RouterParams) {
            if (RouterParams.page_size) {
                appPaginationStore.PageParams.pageSize = Number(RouterParams.page_size);
            }

            if (RouterParams["page"]) {
                /*if(Number(RouterParams.total) % Number(RouterParams.page_size) === 0) {
                    if(currentPage > 1) { currentPage--; }
                }*/
                appPaginationStore.setCurrent(Number(RouterParams["page"]));
            }

            this.pagination = {...appPaginationStore.PageParams};
        }

        //TODO::Добавить фильтр и склеить с существующим

        // try {
        if (filter) {
            this.proxyFilter = filter;
        }
        await this.fetchTable(this, null, this.proxyFilter);
        // } catch (e) {
        //     console.log("CreateProxy Error :" + e);
        // }
    }

    async handleTableChange(pagination: Record<string, any>): Promise<void> {
        this.TableLoading = true;
        const pager = {...pagination};
        this.pagination = pager;

        this.$router.currentRoute.params.page_size = pager.pageSize

        await this.fetchTable(this, pager, this.proxyFilter);
    }


    async ApplyTableFilter(): Promise<void> {
        const params =
            Vue.router.currentRoute.params !== undefined && Vue.router.currentRoute.params["filter"] !== undefined
                ? Vue.router.currentRoute.params["filter"]
                : null;

        if (params) {
            try {
                this.proxyFilter = JSON.parse(params)
                await this.fetchTable(this, null, JSON.parse(params));
            } catch (e) {
                console.log("Proxy Table Error: " + e);
            }
        }
    }

    async setRouteFilterTable(source: string, value: Record<string, any>, proxyData: boolean): Promise<void> {
        const params = Vue.router.currentRoute.params !== undefined &&
        Vue.router.currentRoute.params["filter"] !== undefined ?
            Vue.router.currentRoute.params["filter"] : null;

        let dta: Record<string, any> = {};

        if (params !== null) {
            const check = JSON.parse(params);
            dta = Object.assign(check, value);
        } else {
            dta = value;
        }

        if (proxyData) {
            try {
                await this.fetchTable(this, null, value);
            } catch (e) {
                console.log("Proxy Table Error: " + e);
            }
        }
        Object.keys(dta).forEach((key) => {
            if (dta[key] === "0") {
                delete dta[key];
            }
        });
        let props: any = null;
        if (this.$router.currentRoute["meta"]) {
            props = this.$router.currentRoute["meta"]["props"];
        }
        if (props) {
            await Vue.router.replace({
                name: props.source["routePage"],
                params: {
                    page: "1",
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(dta),
                },
            });
        }
    }

    async fetchTable(that: this, pager?: any, filter?: Record<string, any>): Promise<void> {
        let Pagination = {...that.pagination};
        if (pager) {
            Pagination = pager;
        }
        let param: Record<string, any>;
        let filterData: any = {};
        let studio_id = this.$store.state["salon_id"];

        // Добавляем
        if (this.$router.currentRoute.params["Studio"] && Number(this.$router.currentRoute.params["Studio"]) !== 0) {
            studio_id = this.$router.currentRoute.params["Studio"];
        }
        if (this.$route.params["client_id"] && filter) {
            filterData = {
                salon_id: filter.studio_id,
            }
        } else {
            filterData = {
                salon_id: studio_id,
            }
        }

        if (this.$router.currentRoute.params["Studio"] !== undefined && Number(this.$router.currentRoute.params["Studio"]) === 0) {
            filterData = {};
        }
        if (filter) {
            filterData = {...filterData, ...filter};
            //TODO::Добавить склеивание фильтра
        } else {
            if (this.$router.currentRoute.params["filter"]) {
                const filterFromRoute = JSON.parse(this.$router.currentRoute.params["filter"]);
                // Если у нас salon_id в обоих объектах, то удаляю тот, который в роуте
                if (filterData.salon_id && filterFromRoute.salon_id) {
                    delete filterFromRoute.salon_id;
                }
                filterData = {...filterData, ...filterFromRoute};
            }
        }
        param = {
            skip: this.calcSkip(Pagination),
            limit: Pagination.pageSize,
            filter: filterData,
        };

        if (this.sort_mod) {
            param = {
                skip: this.calcSkip(Pagination),
                limit: Pagination.pageSize,
                filter: filterData,
                sort: this.proxySort.sort,
                by: this.proxySort.by
            }
        }

        // try {
        let props: any = null;
        if (this.$router.currentRoute["meta"]) {
            props = this.$router.currentRoute["meta"]["props"];
        }


        // ----- fix absent active parameter for stuidos fetch query (Starting line.) -----
        var routeParamsLocal =
          Vue.router.currentRoute.params !== undefined && Vue.router.currentRoute.params["filter"] !== undefined
              ? JSON.parse(Vue.router.currentRoute.params["filter"])
              : null;

        if (routeParamsLocal && (routeParamsLocal.active === true || routeParamsLocal.active === false)) {
            param.filter.active = routeParamsLocal.active.toString();

        }
        // ----- fix absent active parameter for stuidos fetch query (Ending line.) -----

        await this.$store.dispatch(props["source"]["name"] + "/fetchAll", param).then(async () => {
            that.pagination.total = props.source["items"] === 'loyaltySubscription' ? that.$store.state[props.source["root"]]['loyaltySubscriptions']["total"] : that.$store.state[props.source["root"]][props.source["items"]]["total"];
            if (pager) {
                that.TableLoading = true;
                appPaginationStore.PageParams.pageSize = pager.pageSize;
                appPaginationStore.setCurrent(pager["current"]);

                await that.$router.push({
                    name: props.source["routePage"],
                    params: {
                        page: pager["current"],
                        page_size: pager["pageSize"],
                        total: String(that.pagination.total),
                        filter: JSON.stringify(filterData),
                    },
                });
            }

            appPaginationStore.PageParams.total = that.pagination.total
            if (that.pagination.total > 10) {
                that.pagination.current = 1
            }
        });
        // } catch (e) {
        //     console.error("ProxyTableData Ошибка получения данных:" + e.message);
        //     console.error("stack: ", e.stack);
        // }
    }
}
